import React from 'react';
import ReactDOM from 'react-dom';
import fetch from 'isomorphic-fetch';
import { FormattedMessage } from 'react-intl';
import { connect } from 'react-redux';
import { Modal, Button, Icon, Select } from 'antd';
import classNames from 'classnames/bind';
import Enum from 'utils/EnumsManager';
import { objTypeAndClassTypeMap } from 'config/app.config';
import { baseUrl } from 'config/env.config';
import { fetchObjectAllFields } from 'views/Setup/SearchLayout/flow/action';
import { resetFilterValue } from 'components/page/ObjectFilter/components/FieldsSelection/flow/actions';
import FieldsSelection from 'components/page/ObjectFilter/components/FieldsSelection/index';
import { getAuthorization } from 'utils/common';
import { fetchImportRequiredFields } from '../flow/action';
import styles from '../index.less';

const cx = classNames.bind(styles);
const { Option } = Select;
const { Leads } = Enum.ObjectTypes;

class ExportTemplateModal extends React.Component {
  state = {
    visible: false,
    objectType: Leads
  }

  handleModalOpen = () => {
    const { fetchObjectAllFields, fetchImportRequiredFields } = this.props;
    const { objectType } = this.state;
    this.setState({ visible: true });
    fetchImportRequiredFields(objectType);
    fetchObjectAllFields(objectType);
  }

  handleModalClose = () => {
    const { resetFilterValue } = this.props;
    resetFilterValue();
    this.setState({ visible: false });
  }

  handleDownload = () => {
    const access_token = getAuthorization();
    const { objectType } = this.state;
    const { selectedFields } = this.props;
    const fields_ids = selectedFields.map(field => {
      if (!field.is_restricted_to_me) {
        return field.id;
      }
    });
    const downloadURL = `${baseUrl}/admin/objects/import-template/download`;
    fetch(`${downloadURL}`, {
      method: 'POST',
      headers: {
        Authorization: access_token,
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        object_type: objectType,
        field_ids: fields_ids
      })
    }).then(fileData => fileData.blob()).then(blob => {
      const a = document.createElement('a');
      const url = window.URL.createObjectURL(blob);
      document.body.appendChild(a);
      a.style = 'display: none';
      a.href = url;
      a.download = 'Import_Template.csv';
      a.click();
      a.remove();
      window.URL.revokeObjectURL(url);
    });
  }

  render() {
    const { visible, objectType } = this.state;
    const colLayout = {
      xs: 24,
      sm: 11,
    };
    const rowLayout = {
      gutter: 16,
    };

    const footer = [
      (
        <Button onClick={this.handleModalClose} className={cx('template-modal-cusbtn')}>
          <FormattedMessage id="global.ui.button.cancel" />
        </Button>
      ),
      (
        <Button key="submit" type="primary" onClick={() => this.handleDownload()}>
          <FormattedMessage id="page.ObjectImport.download" />
        </Button>
      ),
    ];

    return (
      <React.Fragment>
        <Button className="btn-ellipse ml-sm" size="small" onClick={() => this.handleModalOpen()}>
          <Icon type="download" />
          <FormattedMessage id="page.ObjectImport.downloadTemplate" />
        </Button>
        <Modal
          title={<FormattedMessage id="page.ObjectImport.exportTemplate" />}
          visible={visible}
          footer={footer}
          onCancel={() => this.handleModalClose()}
        >
          <div style={{ display: 'none' }} id="downloadDiv" />
          <FormattedMessage id="page.ObjectImport.selectObject">
            {text => <span className={cx('template-modal-title')}>1. {text}</span>}
          </FormattedMessage>
          <Select className="full-width mt-md" value={objectType}>
            <Option value={Leads}><FormattedMessage id={`global.sider.${Leads}`} /></Option>
          </Select>
          <FormattedMessage id="page.ObjectImport.selectFields">
            {text => <div className={classNames(cx('template-modal-title'), 'mt-xlg')}>2. {text}</div>}
          </FormattedMessage>
          <div className="mt-md">
            <FieldsSelection
              cardCustomClass="modal-select-field"
              colLayout={colLayout}
              rowLayout={rowLayout}
              theme={objTypeAndClassTypeMap[objectType]}
              NeedRestriction
            />
          </div>
        </Modal>
      </React.Fragment>
    );
  }
}

const mapStateToProps = ({ global, objectView }) => ({
  lang: global.language,
  selectedFields: objectView.fields.selectedFields
});

const mapDispatchToProps = {
  fetchObjectAllFields,
  resetFilterValue,
  fetchImportRequiredFields
};

export default connect(mapStateToProps, mapDispatchToProps)(ExportTemplateModal);



// WEBPACK FOOTER //
// ./src/views/Setup/ObjectImport/component/ExportTemplateModal.jsx